import request from "@/common/request.js";

export function getDirectorContact() {
  return request({
    url: "/system/directorContact/get",
    method: "post",
  });
}

export function listInform(data) {
  return request({
    url: "/system/notice/listInform",
    method: "post",
    params: data,
  });
}

export function listNews(data) {
  return request({
    url: "/system/notice/listNews",
    method: "post",
    params: data,
  });
}

export function getNoticeDetail(id) {
  return request({
    url: "/system/notice/detail/" + id,
    method: "get",
  });
}
